<p-calendar v-model="proxyDate" :showTime="true" :showSeconds="true" appendTo="body" dateFormat="dd/mm/yyyy"></p-calendar>